module.exports = __webpack_public_path__ + "static/media/profile-default.8a140fd3.svg";